import React from 'react';
import { Link } from 'react-router-dom';

const ModuleCard = ({ module, hasAccess = true, compact = false }) => {
  const baseClasses = "border rounded-lg shadow-md transition-all duration-300 overflow-hidden";

  // Classes conditionnelles selon l'accès
  const accessClasses = hasAccess
    ? "bg-white dark:bg-gray-900 hover:shadow-lg group cursor-pointer"
    : "bg-gray-100 dark:bg-gray-800 opacity-60 cursor-not-allowed";

  const cardClasses = module.specialStyle && hasAccess
    ? `${module.specialStyle} ${module.colors.border}`
    : `${baseClasses} ${accessClasses} ${module.colors.border}`;

  const icon = React.isValidElement(module.icon)
    ? React.cloneElement(module.icon, {
      className: [
        compact ? 'w-6 h-6' : 'w-12 h-12',
        module.icon.props?.className || '',
      ].join(' ').trim(),
    })
    : module.icon;

  const CardContent = () => (
    <div className={`flex flex-col h-full ${compact ? 'p-3' : 'p-5'}`}>
      <div className="flex items-center mb-3">
        <div className="flex-shrink-0 mr-3">
          <div
            className={[
              hasAccess ? module.colors.bg : 'bg-gray-200 dark:bg-gray-700',
              compact ? 'p-2' : 'p-3',
              'rounded-full',
            ].join(' ')}
          >
            <div className={`${hasAccess ? module.colors.text : 'text-gray-400 dark:text-gray-500'}`}>
              {icon}
            </div>
          </div>
        </div>

        <div className="flex items-center flex-wrap">
          <h2 className={`${compact ? 'text-base' : 'text-lg'} font-bold text-left ${
            hasAccess
              ? (module.isAdminOnly
                  ? 'text-indigo-800 dark:text-indigo-200'
                  : 'text-gray-800 dark:text-white')
              : 'text-gray-500 dark:text-gray-400'
          }`}>
            {module.name}
          </h2>
          {module.isAdminOnly && hasAccess && (
            <span className="ml-2 px-1.5 py-0.5 text-xs font-semibold bg-indigo-200 dark:bg-indigo-800 text-indigo-700 dark:text-indigo-300 rounded-full">
              Admin
            </span>
          )}
        </div>
      </div>

      <div className="flex-grow text-left">
        <p className={`${compact ? 'text-xs leading-snug' : 'text-sm'} ${
          hasAccess
            ? (module.isAdminOnly
                ? 'text-indigo-700 dark:text-indigo-300'
                : 'text-gray-600 dark:text-gray-300')
            : 'text-gray-500 dark:text-gray-400'
        }`}>
          {module.description}
        </p>

        {!hasAccess && (
          <div className="mt-3 text-gray-400 dark:text-gray-500 flex items-center text-sm">
            <span>Permissions requises</span>
            <svg className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );

  // Si l'utilisateur n'a pas accès, ne pas rendre le lien cliquable
  if (!hasAccess) {
    return (
      <div className={cardClasses}>
        <CardContent />
      </div>
    );
  }

  return (
    <Link to={module.path} className={cardClasses}>
      <CardContent />
    </Link>
  );
};

export default ModuleCard;